<template>
  <Drawer
    :title="title"
    custom-class="pg-drawer-print-template-select"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :size="size"
    @close="close"
    @closed="closed"
    @opened="opened"
  >
    <div class="pg-drawer-print-template-select__content">
      <div class="pg-drawer-print-template-select__seach">
        <Input clearable v-model="keyword" @input="change">
          <i slot="prefix" class="ivu-icon-icon-pg-serach"></i>
        </Input>
      </div>
      <PgTable
        class="pg-drawer-print-template-select__table"
        ref="tableRef"
        height="auto"
        buttonColumnWidth="180"
        :buttonRow="buttonRow"
        :rowShortcutNum="2"
        :customAction="customAction"
        :column="column"
        :columnTableCode="columnTableCode"
        showPagination
        @size-change="() => getData()"
        @current-change="() => getData()"
        @cell-click="cellClick"
      >
      </PgTable>
      <PgDrawerForm
        title="修改"
        :visible.sync="editVisible"
        :formItemsCode="editFormItemsCode"
        :formParam="editFormParam"
        :formUrl="editFormUrl"
        :submitUrl="editSubmitUrl"
        @on-ok="editOk"
      />
    </div>
  </Drawer>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { Drawer, Input, Loading } from 'element-ui'
import { useGetData } from '../hook/use-get-data'
import { ref, toRef, shallowRef } from 'vue'
import { useDrawerPack } from '../../../hooks/index'
import { post } from '../../../utils/index'
import { pgMessageBox } from '../../message-box/index'
import { usePrint } from '../hook/use-print'

const props = defineProps({
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '打印模板',
  },
  modal: {
    type: Boolean,
    default: true,
  },
  size: {
    type: [String, Number],
    default: 900,
  },
  column: {
    type: [Array, Object],
    default: () => [
      // {
      //   property: 'code',
      //   label: '模板编码',
      //   width: '150px',
      // },
      {
        property: 'default',
        label: '是否默认',
        componentCode: 'cellBoolean',
        align: 'center',
      },
      {
        property: 'name',
        label: '模板名称',
      },
      {
        property: 'preset',
        label: '是否预置',
        componentCode: 'cellBoolean',
        align: 'center',
      },
      // {
      //   property: 'server.name',
      //   label: '打印方式',
      //   width: '120px',
      // },
      // {
      //   property: 'print.papper',
      //   label: '纸张大小',
      //   width: '80px',
      // },
      // {
      //   property: 'print.orientation',
      //   label: '纸张方向',
      //   width: '80px',
      // },
    ],
  },
  columnTableCode: String,
  dataUrl: String,
  dataParameters: Object,
  editFormItemsCode: {
    type: String,
    default: 'UNION_GSP_PRINT_EDIT_EDIT_FORM',
  },
  editFormUrl: {
    type: String,
    default: 'rest/ezcomp/report/templateInfo',
  },
  editSubmitUrl: {
    type: String,
    default: 'rest/ezcomp/report/templateRename',
  },
  removeUrl: {
    type: String,
    default: 'rest/ezcomp/report/templateRemove',
  },
  copyUrl: {
    type: String,
    default: 'rest/ezcomp/report/templateCopy',
  },
  setDefaultUrl: {
    type: String,
    default: 'rest/ezcomp/report/setDefault',
  },
  orderData: [Object, Array],
  extendData: Object,
  savePrintCount: String,
  savePrintCountParams: Object,
  orderDataId: {
    type: String,
    default: 'id',
  },
  //调用打印时的前置钩子，接收参数为 {printTemplate, orderData, extendData}
  //printTemplate为选择的打印模板详情数据，可在打印模板中配置 printTemplate.dataset.printBefore 来对该打印模板打印前特俗逻辑处理
  //该函数支持异步，如有返回值则会覆盖props.orderData
  printBefore: Function,
  //发生错误时是否抛出on-ok-and-continue事件，为false时统一抛出on-ok-and-continue
  cancel: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:visible', 'close', 'on-cancel', 'on-ok-and-continue'])
const { showDrawer, close, closed, onCancel } = useDrawerPack(toRef(props, 'visible'), emit)

const { tableRef, keyword, change, opened, getData } = useGetData(
  toRef(props, 'dataParameters'),
  props.dataUrl
)

//编辑打印模板名称等信息
const editVisible = ref(false)
const editFormParam = ref(null)
const edit = (row) => {
  editFormParam.value = { id: row.id }
  editVisible.value = true
}
const editOk = () => {
  opened()
}
//删除模板
const remove = (row) => {
  pgMessageBox({
    message: '确认删除？',
    beforeClose: async (done, type) => {
      if (type === 'confirm') {
        const [res] = await post(props.removeUrl, { id: row.id }, { successTip: 'message' })
        done()
        if (res) {
          opened()
        }
      } else {
        done()
      }
    },
  })
}
//复制模板
const copy = (row) => {
  pgMessageBox({
    message: '确认复制？',
    beforeClose: async (done, type) => {
      if (type === 'confirm') {
        const [res] = await post(props.copyUrl, { id: row.id }, { successTip: 'message' })
        done()
        if (res) {
          opened()
        }
      } else {
        done()
      }
    },
  })
}
//自定义模板
const design = (row) => {
  window.open(row.edit.split('?')[0])
}
// 设置默认打印模板
const setDefault = async (row) => {
  pgMessageBox({
    message: '确认设为默认打印模板？',
    beforeClose: async (done, type) => {
      if (type === 'confirm') {
        const [res] = await post(
          props.setDefaultUrl,
          { id: row.id, catalog: row.catalog.code },
          { successTip: 'message' }
        )
        done()
        if (res) {
          opened()
        }
      } else {
        done()
      }
    },
  })
}

const { print } = usePrint({
  orderData: props.orderData,
  extendData: props.extendData,
  savePrintCount: props.savePrintCount,
  orderDataId: props.orderDataId,
  savePrintCountParams: props.savePrintCountParams,
  printBefore: props.printBefore,
})
//打印
const cellClick = async ({ row }) => {
  let loadingInstance1 = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  const res = await print(row)?.catch((error) => ({ type: 'error', error }))
  loadingInstance1.close()
  if (!props.cancel || res?.type !== 'error') {
    emit('on-ok-and-continue')
  }
}

const customAction = (menu, { row }) => {
  switch (menu.doing.property.methodName) {
    case 'copy':
      return copy(row)
    case 'remove':
      return remove(row)
    case 'edit':
      return edit(row)
    case 'design':
      return design(row)
    case 'setDefault':
      return setDefault(row)
    case 'print':
      return cellClick({ row })
  }
}
const buttonRow = shallowRef([
  {
    code: 'print',
    name: '打印',
    doing: {
      action: {
        code: 'method',
      },
      property: {
        methodName: 'print',
      },
    },
    style: '',
  },
  {
    code: 'setDefault',
    name: '设为默认',
    doing: {
      action: {
        code: 'method',
      },
      property: {
        methodName: 'setDefault',
      },
    },
    showExp: '{{!row.default}}',
  },
  {
    code: 'design',
    name: '设计',
    doing: {
      action: {
        code: 'method',
      },
      property: {
        methodName: 'design',
      },
    },
    showExp: "{{!row.preset && row.server && row.server.code === 'jmreport'}}",
  },
  {
    code: 'copy',
    name: '复制',
    doing: {
      action: {
        code: 'method',
      },
      property: {
        methodName: 'copy',
      },
    },
    style: '',
  },
  {
    code: 'remove',
    name: '删除',
    doing: {
      action: {
        code: 'method',
      },
      property: {
        methodName: 'remove',
      },
    },
    showExp: '{{!row.preset}}',
    style: 'error',
  },
  {
    code: 'edit',
    name: '修改',
    doing: {
      action: {
        code: 'method',
      },
      property: {
        methodName: 'edit',
      },
    },
    showExp: '{{!row.preset}}',
  },
])
</script>
<style lang="scss">
@import '../style/drawer-print-template-select.scss';
</style>
